import ComingSoonPage from './components/ComingSoonPage';

function App() {
  return (
    <ComingSoonPage />
  );
}

export default App;